export function normalizeDiagnosisCode(code: string): string {
  return code.replace(/\./g, "").trim().toUpperCase();
}

export function diagnosisCodeMatches(pattern: string, code: string): boolean {
  const normalizedPattern = normalizeDiagnosisCode(pattern);
  const normalizedCode = normalizeDiagnosisCode(code);

  return normalizedCode.startsWith(normalizedPattern);
}
